import React, { Component } from "react";
import PropTypes from "prop-types";
import { PaymentService } from "@services";
import utils from "@utils";
import Modal from "../Modal/Modal";

import "./BankVerificationModal.scss";

class BankVerificationModal extends Component {
	constructor(props) {
		super(props);

		this.state = {
			show: false,
			bankAccountId: "",
			loading: false,
			form: {
				amountOne: "",
				amountTwo: "",
			},
			validation: {
				amountOne: false, // true = has error
				amountTwo: false,
			},
		};

		this.initialState = { ...this.state };
	}

	openModal = bankAccountId => {
		this.setState({ show: true, bankAccountId });
	};

	/** Validates that input fields have values and makes a request to a bank account verification endpoint */
	onSubmit = () => {
		const { lang } = global;
		const { bankAccountId, form, validation } = this.state;
		const { organizationId, callback } = this.props;

		// Validate form
		const newValidations = { ...validation };
		newValidations.amountOne = form.amountOne === "";
		newValidations.amountTwo = form.amountTwo === "";

		// If any validation property is true, the form is not valid
		const validationError = Object.values(newValidations).some(item => item);
		this.setState({ validation: newValidations, loading: !validationError });

		if (validationError) return;

		const endpoint = organizationId ? "verifyOrganizationBankAccount" : "verifyBankAccount";

		let params = {
			BankAccountId: bankAccountId,
			AmountOne: form.amountOne,
			AmountTwo: form.amountTwo,
		};

		if (organizationId) {
			params = {
				Id: bankAccountId,
				Amount1: form.amountOne,
				Amount2: form.amountTwo,
				organizationId,
			};
		}

		PaymentService[endpoint](params)
			.then(() => {
				this.setState(this.initialState);

				utils.notify({
					type: "success",
					message: lang.t("Bank Account verified successfully"),
				});

				if (callback) callback();
			})
			.catch(({ response }) => {
				this.setState({ loading: false });

				utils.notify({
					type: "error",
					message: response?.data.Message ?? lang.t("Error verifying bank account"),
				});
			});
	};

	onCancel = () => {
		this.setState(this.initialState);
	};

	onFormChange = property => event => {
		const value = event?.target?.value ?? "";

		this.setState(state => ({
			form: { ...state.form, [property]: value.replace(/\D/g, "") },
		}));
	};

	render() {
		const { lang } = global;
		const { show, form, validation, loading } = this.state;

		return (
			<Modal
				id="bank-verification-modal"
				size="sm"
				show={show}
				onHide={this.onCancel}
			>
				<Modal.Header closeButton>
					<Modal.Title>{lang.t("Verify Bank Account")}</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					<div className="text-center">
						<h4>{lang.t("Microdeposit amounts in cents")}</h4>
					</div>
					<br />
					<div className={`row form-group ${validation.amountOne ? "has-error" : ""}`}>
						<div className="col-xs-6 text-right">
							<label htmlFor="amountOne">{`${lang.t("First Deposit")}:`}</label>
						</div>
						<div className="col-xs-5">
							<input
								type="tel"
								className="form-control"
								value={form.amountOne}
								onChange={this.onFormChange("amountOne")}
							/>
						</div>
					</div>
					<div className={`row form-group ${validation.amountTwo ? "has-error" : ""}`}>
						<div className="col-xs-6 text-right">
							<label htmlFor="amountTwo">{`${lang.t("Second Deposit")}:`}</label>
						</div>
						<div className="col-xs-5">
							<input
								type="tel"
								className="form-control"
								value={form.amountTwo}
								onChange={this.onFormChange("amountTwo")}
							/>
						</div>
					</div>

					<br />
					<div className="row">
						<div className="col-xs-6">
							<button
								type="button"
								id="bank-account-verification-cancel"
								className="btn btn-link btn-block"
								onClick={this.onCancel}
								disabled={loading}
							>
								{lang.t("Cancel")}
							</button>
						</div>
						<div className="col-xs-6">
							<button
								type="button"
								id="verify-bank-account"
								className="btn btn-primary btn-block"
								onClick={this.onSubmit}
								disabled={loading}
							>
								{loading ? lang.t("Loading") : lang.t("Verify")}
							</button>
						</div>
					</div>
				</Modal.Body>
			</Modal>
		);
	}
}

BankVerificationModal.propTypes = {
	organizationId: PropTypes.number,
	callback: PropTypes.func,
};

BankVerificationModal.defaultProps = {
	organizationId: undefined,
	callback: undefined,
};

export default BankVerificationModal;
